export default {
  placeholder: 'Vybrať receptúru',
};
